import React, { useEffect } from "react";

import { ReceivingInvoiceDetailsViewModel } from "../../../../viewmodels/receiving/invoices/details/ReceivingInvoiceDetailsViewModel";

import { connect } from "react-redux";

import * as actions from "../../../../store/actions/index";

import { withRouter } from "../../../../shared/utility";

import SlideOver from "../../../../components/slideOver/SlideOver";
import AddReceivingInvoiceForm from "../../../../components/forms/receiving/invoices/AddReceivingInvoiceForm";
import AuditActionLink from "../../../../components/audit/AuditActionLink";
import { useParams } from "react-router-dom";
import EmptyModal from "../../../../components/modals/EmptyModal";
import FormSectionLoadingSkeleton from "../../../../components/operational/FormSectionLoadingSkeleton";
import OperationalDataTableSkeleton from "../../../../components/operational/OperationalDataTableSkeleton";

function ReceivingInvoiceDetails(props: any) {
  const { addSnackbar, logout } = props;

  const { invoiceId } = useParams();

  const {
    addItemToReceivingInvoice,
    barcodeDetails,
    createReceivingInvoice,
    getAllAssemblyItems,
    getAssemblyItemByPlu,
    invoice,
    invoiceItems,
    setInvoiceItems,
    onGenerateBarcodePdf,
    loading,
    loadError,
    init,
    setSlideOver,
    slideOver,
    updateReceivingInvoiceApiCall,
    updateReceivingInvoiceStatus,
    setEmptyModelOpen,
    emptyModal,
    showErrorModal,
    openReceivingItemDetails,
    deleteReceivingItem,
    deleteMultipleReceivingItems,
    employeeOptions,
    suppliers,
    printReceivingReportByID,
    getInvoiceProducts,
    getInvoiceLots,
    getInvoiceLotItems,
    lotsLoading,
    itemsLoading,
    purchaseOrderOptions,
    locationOptions,
    zoneOptions,
    loadZonesForLocation,
  } = ReceivingInvoiceDetailsViewModel(
    logout,
    invoiceId as any,
    addSnackbar,
  ) as any;

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#F6F8FB] px-4 py-5 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl space-y-5">
        {loading ? (
          <>
            <div className="rounded-2xl border border-[#E2E8F0] bg-white p-8">
              <FormSectionLoadingSkeleton rows={8} />
            </div>
            <div className="overflow-hidden rounded-2xl border border-[#E2E8F0] bg-white">
              <OperationalDataTableSkeleton
                columns={["Product", "Lot", "Received", "Status"]}
                rows={5}
              />
            </div>
          </>
        ) : invoice.id > 0 ? (
          <>
            <div className="flex flex-wrap items-center justify-between gap-3">
              <h1 className="text-xl font-semibold text-[#0F172A]">
                Receiving invoice {invoice.invoice_number}
              </h1>
              <AuditActionLink
                slug="receiving-invoice"
                id={invoice.id}
                name={invoice.invoice_number}
              />
            </div>
            <AddReceivingInvoiceForm
              addItemToReceivingInvoice={addItemToReceivingInvoice}
              barcodeDetails={barcodeDetails}
              createReceivingInvoice={createReceivingInvoice}
              invoice={invoice}
              isEdit={true}
              onGenerateBarcodePdf={onGenerateBarcodePdf}
              getAllAssemblyItems={getAllAssemblyItems}
              getAssemblyItemByPlu={getAssemblyItemByPlu}
              setSlideOver={setSlideOver}
              invoiceItems={invoiceItems}
              setInvoiceItems={setInvoiceItems}
              updateReceivingInvoiceApiCall={updateReceivingInvoiceApiCall}
              updateReceivingInvoiceStatus={updateReceivingInvoiceStatus}
              showErrorModal={showErrorModal}
              openReceivingItemDetails={openReceivingItemDetails}
              deleteReceivingItem={deleteReceivingItem}
              deleteMultipleReceivingItems={deleteMultipleReceivingItems}
              setEmptyModelOpen={setEmptyModelOpen}
              employeeOptions={employeeOptions}
              suppliers={suppliers}
              printReceivingReportByID={printReceivingReportByID}
              getInvoiceProducts={getInvoiceProducts}
              getInvoiceLots={getInvoiceLots}
              getInvoiceLotItems={getInvoiceLotItems}
              lotsLoading={lotsLoading}
              itemsLoading={itemsLoading}
              purchaseOrderOptions={purchaseOrderOptions}
              locationOptions={locationOptions}
              zoneOptions={zoneOptions}
              loadZonesForLocation={loadZonesForLocation}
            />
          </>
        ) : (
          <div className="rounded-2xl border border-[#E2E8F0] bg-white p-8">
            <h1 className="text-lg font-semibold text-[#0F172A]">
              Could not load receiving invoice
            </h1>
            <p className="mt-2 text-sm text-slate-600" role="alert">
              {loadError || "This receiving invoice could not be loaded."}
            </p>
          </div>
        )}
      </div>

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        customClass="max-w-3xl"
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (_state: unknown) => {
  return {};
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar: any) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReceivingInvoiceDetails),
);
